import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import BlueCheckImg from '../assets/images/certificates/blue_check.png';
import InvalidImg from '../assets/images/certificates/invalid.png';
import HtmlTooltip from './ui/HtmlTooltip';
import InformationIcon from './ui/InformationIcon';
import { border } from '../utils/theme.js';
import Box from '@mui/material/Box';
import EtherImg from '../assets/images/certificates/ether_box.png';
import PolygonImg from '../assets/images/certificates/polygon_box.png';
import Grid from '@mui/material/Grid';

export default function MinterProofs({ proofs, address, proofsLoaded, walletLink, validProofs }) {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                ...border,
                borderRadius: 4,
                px: 2,
                py: 2,
                backgroundColor: proofsLoaded && proofsLoaded.length === 0 ? '#F6F6F6' : '#FFFFFF',
            }}
        >
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'top'} mb={1}>
                <Grid container alignItems={'center'} mb={1}>
                    <Grid size={{ xs: 12, md: 'auto' }}>
                        <Typography variant="subtitle1">{t('certificate.minter_validations')}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 'auto' }} alignItems={'center'} sx={{ ml: { xs: 0, md: 2 } }}>
                        <Stack direction={'row'} spacing={1} alignItems={'center'}>
                            {proofsLoaded?.length > 0 && validProofs && (
                                <img src={BlueCheckImg} alt="valid" height={24} width={24} />
                            )}
                            {!validProofs && <img src={InvalidImg} height={24} width={24} alt="invalid" />}
                            {walletLink && (
                                <a href={walletLink} target="_blank" style={{ textDecoration: 'none' }}>
                                    <Typography variant="link" sx={{ cursor: 'pointer' }}>
                                        {t('certificate.see_wallet')}
                                    </Typography>
                                </a>
                            )}
                        </Stack>
                    </Grid>
                </Grid>
                <HtmlTooltip style={{ marginTop: 4 }} text={t('certificate.not_possible_to_verify')}>
                    <InformationIcon white={false} />
                </HtmlTooltip>
            </Stack>
            <Stack direction={'row'} alignItems={'center'} spacing={1} mb={2}>
                <img alt="polygon" src={PolygonImg} height={35} />
                <img alt="etherum" src={EtherImg} height={35} />
            </Stack>
            <Typography variant="body2" mb={2}>
                {proofsLoaded && proofsLoaded?.length > 0
                    ? t('certificate.crypto_validation')
                    : t('certificate.minter_with_no_validations')}
            </Typography>
            {address && proofs}
        </Box>
    );
}
